import script from "./Cloud.vue?vue&type=script&setup=true&lang=js"
export * from "./Cloud.vue?vue&type=script&setup=true&lang=js"

import "./Cloud.vue?vue&type=style&index=0&id=10ba823c&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10ba823c"]])

export default __exports__